// extracted by mini-css-extract-plugin
export default {"buttonOpenDemo":"DemoSuccess_buttonOpenDemo__pa-Kn"};